import type { FormDataOf } from '../../../../../types/templates';
import type { DynamicOptions, SelectOption } from '../../../../../types/client-handler';
import { disneyEspnVS } from '..';
import { getSportOptions } from './get-sport-options';
import { getDynamicMatchOptions } from './get-dynamic-match-options';

type FormData = FormDataOf<typeof disneyEspnVS>;

export const getDynamicOptions = (
  fieldKey: string,
  formData: FormData,
  creativityType?: string,
  baseOptions?: DynamicOptions
): DynamicOptions | undefined => {
  const matchOptions = getDynamicMatchOptions(fieldKey, formData, creativityType);
  if (matchOptions) return matchOptions;

  const sportOptions = getSportOptions(fieldKey, formData, baseOptions as SelectOption[] | undefined);
  if (sportOptions) return sportOptions;

  return baseOptions;
};
